function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { j as a } from "./index.es33.js";
import { clsx as d } from "./index.es105.js";
import { Typography as f } from "./index.es35.js";
import "./index.es36.js";
import l from "./index.es111.js";
import t from "./index.es124.js";

var j = function j(_ref) {
  var p = _ref.isAutosize,
      s = _ref.minHeight,
      m = _ref.height,
      n = _ref.maxHeight,
      e = _ref.hiddenSpanRef,
      o = _ref.initialWidth,
      r = _ref.value,
      i = _ref.isVariable;
  return p ? a.jsx(f.Body2, {
    className: d(l.input, t.input, t.hiddenSpan, _defineProperty({}, t.variableHiddenSpan, i)),
    as: "span",
    style: {
      minHeight: s,
      height: m,
      maxHeight: n,
      width: o || "auto",
      maxWidth: o || "auto"
    },
    ref: e,
    children: r && "".concat(r, " ")
  }) : null;
};

export { j as HiddenSpan };